<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">ユーザー情報更新</h2>

      <p class="bold_label">名字</p>
      <input type="text" class="text_form" v-model="renewUserDetail.lastName"/>
      <p class="bold_label">名前</p>
      <input type="text" class="text_form" v-model="renewUserDetail.firstName"/>

      <button @click="updateUserDetail()" class="active-rectangle_button">登録</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import toast from '@/assets/js/functions/_core/toast';
  import collection from '@/assets/js/functions/firebase/firestore/collection';

  export default {
    name: "UpdatingUserDetail",

    mixins: [toast, collection],

    data() {
      return {
        renewUserDetail: {
          lastName: '',
          firstName: '',
        },
      }
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    computed: {
      ...mapGetters({customClaim: 'auth/customClaim', uid: 'auth/uid'}),
    },

    methods: {
      isValidUserDetail() {
        if (!this.renewUserDetail.lastName || !this.renewUserDetail.firstName) {
          this.showErrorMessage('未入力の項目があります');
          return false;
        }
        return true;
      },

      async updateUserDetail() {
        if (!this.isValidUserDetail()) return;

        await this.updateDoc(
          COLLECTION_NAMES.USER_DETAILS,
          this.uid,
          this.renewUserDetail
        ).then(async () => {
            this.showSuccessMessage('ユーザー情報を更新しました。');
            this.$router.push({name: 'UserDetail'});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      }
    },
  }

</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include form-contents();
    }
  }
</style>
